import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "-mt-2 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" }

import DescriptionHeader from '@/components/neue/DescriptionHeader.vue'


export default {
  __name: 'ReportsGroup',
  props: {
  title: { type: String, required: true },
  subtitle: { type: String, required: true },
  reports: {
    type: Array,
    required: true
    // each item: { name: string, to: string, icon: Component }
  }
},
  setup(__props) {



return (_ctx, _cache) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(DescriptionHeader, {
      name: __props.title,
      description: __props.subtitle
    }, null, 8, ["name", "description"]),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.reports, (report) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          key: report.to,
          to: report.to,
          class: "border border-gray-300 rounded-lg pl-3 pr-4 py-3 font-medium transition-all hover:scale-[1.02] shadow-sm text-gray-700 bg-white hover:bg-gray-50 flex items-center gap-2"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(report.icon), { class: "h-5 w-5 shrink-0" })),
            _createTextVNode(" " + _toDisplayString(report.name), 1)
          ]),
          _: 2
        }, 1032, ["to"]))
      }), 128))
    ])
  ]))
}
}

}